// extracted by mini-css-extract-plugin
export default {"tabs":"pageTabs_tabs__rCR9Y","tab":"pageTabs_tab__s+wdF","tabActive":"pageTabs_tabActive__Rf-LL"};